import React, { useState } from "react";
import { Cta } from "../../elements/Cta/Cta";
import * as styles from "./LoginForm.module.css";
import * as ctaStyles from "../../elements/Cta/Cta.module.css";
import { LoginFormStyle } from "./LoginForm";

interface Props extends LoginFormStyle {
  prefix?: string;
}

export const EBusinessForm: React.FC<Props> = ({
  style = "light",
  prefix = "",
}) => {
  const [showHelp, setShowHelp] = useState(false);

  const handleHelpButtonClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    setShowHelp(true);
  };

  return (
    <div className={styles.form}>
      <form
        method="post"
        action="https://emprisebank.ebanking-services.com/EamWeb/Remote/RemoteLoginApi.aspx?appID=beb&amp;brand=emprisebank"
      >
        <div className={styles.form}>
          <label
            htmlFor={`${prefix}bus_textBoxCompanyId`}
            className="vis-hidden"
          >
            Company Id
          </label>
          <input
            name="_textBoxCompanyId"
            type="number"
            id={`${prefix}bus_textBoxCompanyId`}
            maxLength={26}
            placeholder="Company ID"
          />
          <label htmlFor={`${prefix}bus_textBoxUserId`} className="vis-hidden">
            User Id
          </label>
          <input
            name="_textBoxUserId"
            type="text"
            maxLength={26}
            id={`${prefix}bus_textBoxUserId`}
            placeholder="User ID"
          />
          {showHelp ? (
            <div className={styles.helpLinks}>
              <p>
                For assistance with your User ID, contact your Company
                Administrator. For further, assistance with your User ID, please
                contact our Customer Service Center at 316-383-4301 or
                855-383-4301, 7:30 a.m. to 8:00 p.m Monday through Friday, or
                8:30 a.m. to 2:00 p.m. on Saturday.
              </p>
            </div>
          ) : (
            <button
              className={styles.helpButton}
              type="button"
              onClick={(e) => handleHelpButtonClick(e)}
            >
              Need help?
            </button>
          )}{" "}
          <button
            name="_buttonContinue"
            type="submit"
            className={[
              ctaStyles.cta,
              style === "light" ? ctaStyles.white : "",
            ].join(" ")}
          >
            Submit
          </button>
        </div>
      </form>
      <div
        className={[
          styles.separator,
          style === "light" ? "" : styles.darkSeparator,
        ].join(" ")}
      >
        &nbsp;&nbsp;or&nbsp;&nbsp;
      </div>
      <Cta
        label="Enroll"
        buttonStyle={style === "light" ? "white" : undefined}
        href="https://emprisebank.ebanking-services.com/Nubi/Trace/Enroll.aspx"
      />
    </div>
  );
};
